export default "# 小休憩(1)\n\n## 各自で進捗に合わせて小休憩を取ってください\n";